import { http } from '@/shared/api'
import type { ApiListResponse, ApiSingleResponse } from '@/shared/api'
import type { ReadOptions } from '@/shared/lib'
import { API } from '@/apps/adok/shared/api'

import type { Balance, BalanceChartPoint, BalanceSummary } from '../model/types'

export interface BalanceRangeParams {
  from: string
  to: string
}

// Hand-written rather than `createEntityApi`: a singular resource, no id in its path.
export const getBalance = (options?: ReadOptions) =>
  http.get<ApiSingleResponse<Balance>>(API.balance, { signal: options?.signal })

export const getBalanceChart = (
  params: BalanceRangeParams,
  options?: ReadOptions
) =>
  http.get<ApiListResponse<BalanceChartPoint>>(`${API.balance}/chart`, {
    params,
    signal: options?.signal
  })

export const getBalanceSummary = (
  params: BalanceRangeParams,
  options?: ReadOptions
) =>
  http.get<ApiSingleResponse<BalanceSummary>>(`${API.balance}/summary`, {
    params,
    signal: options?.signal
  })
